<div (click)="eventCall('POPOVER')" class="image-gallery"
  [style.backgroundImage]="'url(' + activeBackground?.url + ')'">
  <div class="image-row" *ngIf="images">
    <div>
      <span class="image-count">
        <i class="fa fa-image"></i>
        {{images?.length}}
      </span>
      <span class="circle-icon">
        <i class="fa fa-circle"></i>
      </span>
      <span (click)="eventCall('POPOVER')">All Photos</span>
    </div>
    <div>
    </div>
  </div>
  <div class="toggle-icon">
    <span class="icon left-icon" (click)="prevImage()">
      <i class="fa fa-angle-left"></i>
    </span>
    <span class="icon right-icon" (click)="nextImage()">
      <i class="fa fa-angle-right"></i>
    </span>
  </div>
  <div class="ratings-row" *ngIf="hotelDetails">
    <span>
      <span class="average-rating" *ngIf=" hotelDetails.reviews && hotelDetails.reviews[0]?.rating > 0">
        {{hotelDetails.reviews[0]?.rating | number : '.1'}}
      </span>
      <span class="reviews" *ngIf="hotelDetails.reviews && hotelDetails.reviews[0]?.count > 0">
        {{hotelDetails.reviews[0]?.count}} reviews
      </span>
    </span>
    <span class="star-ratings" *ngIf="hotelDetails.starRating">
      <travel-ui-ratings [setRating]="hotelDetails.starRating"></travel-ui-ratings>
    </span>
  </div>
</div>